import { Navigate, useLocation } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  let id = window.location.href.split("/")
  id = id[id.length - 1]
  // console.log(id, 'url is here...')
  const isLoggedIn = localStorage.getItem("STG_TOKEN");
  if (!id || id === "undefined" || id === "null" || !isLoggedIn) {
    return <Navigate to="/login" replace />;
  }
  if (
    location.pathname.startsWith("/courses/") && !location.state
  ) {
    return <Navigate to="/courses" replace />;
  }
  return children;
};

export default ProtectedRoute;
